import {  GUID } from "app/brightserve/brightserve.module";
import { Client } from "app/shared/shared.module";

export class User {
    Id: GUID;
    Name: string;
    Username: string;
    LastLogon: Date;
    LastPasswordChange: Date;
    Privileges: number;
    IsAdmin: boolean;
    IsDoctor: boolean;
    IsClient: boolean;
    LogonEntity: Client;
    UserType: string;

    constructor(init?: Partial<User>) {
        Object.assign(this, init);
    };
}



// WEBPACK FOOTER //
// ./src/app/shared/user.ts